import JSONAPIClient from '../../JSONAPIClient'

JSONAPIClient.define('auth_signing_url', { redirect_url: '' })
